// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1hosS","col":"styles_col__1G0pf"};